import spinner from "@/assets/img/spinner.gif";
import { TMessage } from "@/i18n/tt";

import { useTranslation } from "@/stores/RootStoreContext";

export function LoadingOverlay({ message }: { message?: TMessage }) {
  const { t } = useTranslation();
  const alt: TMessage = message ? message : { key: "loading" };
  return (
    <div
      className={
        "absolute inset-0 bg-default-dimmed50 z-10 h-full w-full justify-center flex items-center"
      }
    >
      <img src={spinner} alt={t(alt)} width={80} />
    </div>
  );
}
